export const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");

    if (digits.startsWith("02")) {
        // 서울 지역번호: 02-XXXX-XXXX or 02-XXX-XXXX
        return digits.length === 9
            ? digits.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3")
            : digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    }

    // 010, 011 등 11자리 or 지역번호 10자리
    return digits.length === 11
        ? digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
        : digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
};
